import { Component, Input, OnInit, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatAngularModule } from '../../modules/mat-angular.module';

export interface BrandAnalysis {
  name: string;
  strengths: string[];
  improvements: string[];
  isYouBrand?: boolean;
}

export interface StrengthsImprovementData {
  brands: BrandAnalysis[];
  title?: string;
  subtitle?: string;
}

@Component({
  selector: 'app-common-strengths-improvement',
  standalone: true,
  imports: [
    CommonModule,
    MatAngularModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './common-strengths-improvement.component.html',
  styleUrl: './common-strengths-improvement.component.scss'
})
export class CommonStrengthsImprovementComponent implements OnInit, OnChanges {
  @Input() data: StrengthsImprovementData | null = null;
  @Input() title: string = 'Strengths and Areas for Improvement';
  @Input() subtitle: string = 'Comprehensive analysis of brand performance';
  @Input() showCard: boolean = true;

  ngOnInit(): void {
    // Component initialization
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      // Handle data changes
    }
  }

  // Check if component has data
  hasData(): boolean {
    return !!(this.data && this.data.brands && this.data.brands.length > 0);
  }

  // Determine if we should show single brand analysis
  shouldShowSingleBrand(): boolean {
    return this.hasData() && this.data!.brands.length === 1;
  }

  // Determine if we should show multiple brands analysis
  shouldShowMultipleBrands(): boolean {
    return this.hasData() && this.data!.brands.length > 1;
  }

  // Check if a brand is the "you" brand
  isYouBrand(brand: BrandAnalysis): boolean {
    if (!brand) return false;
    return brand.isYouBrand || false;
  }

  // Get single brand data
  getSingleBrand(): BrandAnalysis | null {
    if (!this.hasData() || this.data!.brands.length === 0) return null;
    return this.data!.brands[0];
  }

  // Get multiple brands data
  getMultipleBrands(): BrandAnalysis[] {
    if (!this.hasData()) return [];
    return this.data!.brands;
  }
}
